import React from "react";
import { ProductsSection } from "./ProductsSection";

interface BestSellersSectionProps {
  bestSellers: any[];
  allBestSellers: any[];
  isLoading?: boolean;
}

/**
 * Section "Nos Best Sellers" - Affiche les produits mis en avant (est_en_avant)
 */
export const BestSellersSection: React.FC<BestSellersSectionProps> = ({
  bestSellers,
  allBestSellers,
  isLoading = false,
}) => {
  return (
    <ProductsSection
      title="NOS MEILLEURES VENTES"
      products={bestSellers}
      isLoading={isLoading}
      showViewMore={allBestSellers.length > 4}
      viewMoreText="Voir plus"
      viewMoreLink="/produits"
    />
  );
};
